import React, { useEffect, useRef, useState } from 'react';
import { strings } from '../constants/strings';
import { colors } from '../constants/colors';
import { CheckCircle2, TrendingUp } from 'lucide-react';

const SuccessCard = ({ project, isVisible, index }) => {
  return (
    <div 
      className={`success-card ${isVisible ? 'fade-in-up' : ''}`}
      style={{ animationDelay: `${index * 0.1}s` }}
    >
      <div className="success-header">
        <div className="success-logo-container">
          <img src={project.logo} alt={project.partner} className="success-card-logo" />
        </div>
        <div className="success-partner-info">
          <span className="success-domain">{project.domain}</span>
          <h3 className="success-partner">{project.partner}</h3>
        </div>
      </div>
      
      <div className="success-body">
        <div className="success-section-title">
          <CheckCircle2 size={18} color={colors.primary} />
          <span>Services Provided</span>
        </div>
        <p className="success-what-we-did">{project.whatWeDid}</p>
      </div>

      <div className="success-impact-box">
        <div className="success-impact-title">
          <TrendingUp size={18} color={colors.accent} />
          <span>Business Impact</span>
        </div>
        <p className="success-impact-text">{project.impact}</p>
      </div>
    </div>
  );
};

const Portfolio = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  return (
    <section id="portfolio" className="section-padding" ref={sectionRef} style={{ background: colors.backgroundAlt }}>
      <div className="container">
        <div className={`section-header ${isVisible ? 'fade-in-up' : ''}`} style={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2 className="section-title">{strings.portfolio.title}</h2>
        </div>
        
        <div className="portfolio-ticker-container">
          <div className="portfolio-grid animate-scroll" style={{ animationDuration: '40s' }}>
            {/* Duplicate the array to create a seamless loop */}
            {[...strings.portfolio.projects, ...strings.portfolio.projects].map((project, index) => (
              <SuccessCard 
                key={index} 
                project={project} 
                isVisible={isVisible} 
                index={index} 
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
